import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditCraneComponent } from '@app/core/windows'; 


@Component({
  selector: 'cranes-crud',
  templateUrl: './cranes-crud.component.html',
  providers: [ DatasourceService ]
})
export class CranesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditCraneComponent, {static: false}) window !: CreateEditCraneComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Grúa';

  protected name: string = 'Grúas';

  protected table: string = 'cranes';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}